import { UAE } from "../constants";
import {
  MIN_SHAREHOLDER_PERCENTAGE,
  UAE_SHAREHOLDER_PERCENTAGE
} from "../containers/MultiPatnerJourney/constants";

/**
 * Memoization cache for the checkIfEfrNotRequiredForNonSignatory function
 * @type {Map<string, boolean>}
 */
const efrRequirementCache = new Map();

/**
 * Checks if EFR is not required for a non-signatory based on specific criteria
 * @param {Object} signatoryDetail - The signatory details object
 * @returns {boolean} - True if EFR is not required, false otherwise
 */
export const checkIfEfrNotRequiredForNonSignatory = signatoryDetail => {
  // Create a cache key based on relevant properties
  const cacheKey = JSON.stringify({
    isSignatory: signatoryDetail?.kycDetails?.isSignatory,
    nationality: signatoryDetail?.kycDetails?.nationality,
    shareHoldingPercentage: signatoryDetail?.kycDetails?.shareHoldingPercentage
  });

  // Return cached result if available
  if (efrRequirementCache.has(cacheKey)) {
    return efrRequirementCache.get(cacheKey);
  }

  // Original function logic
  if (!signatoryDetail?.kycDetails) {
    return false;
  }

  const {
    kycDetails: { isSignatory, nationality, shareHoldingPercentage }
  } = signatoryDetail;

  const isBelowMinShareholding = parseFloat(shareHoldingPercentage) < MIN_SHAREHOLDER_PERCENTAGE;
  const isUAEWithExactShareholding =
    parseFloat(shareHoldingPercentage) === UAE_SHAREHOLDER_PERCENTAGE && nationality === UAE;

  const result = isSignatory === false && (isBelowMinShareholding || isUAEWithExactShareholding);

  // Cache the result
  efrRequirementCache.set(cacheKey, result);

  return result;
};
